<template>
  <div class="price">
    <div class="price__panel">
      <div class="price__panel__display">
        {{ $n(price, 'currency') }} {{ $tc('base.priceType', exclTax) }}
      </div>
      <p class="price__panel__subtitle">
        {{ $t('comparator.offers.offer.rateGuaranteed') }}
      </p>
    </div>
    <p v-if="isCeilingVisible" class="price__repayment">
      {{ $t('comparator.offers.offer.repaymentCeiling')}} :
      <span
        class="price__repayment__price"
        :class="isWarning">
        {{ $n(repaymentCeiling, 'currency') }}
      </span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import offersHelper from '@/utils/helpers/offers';

export default {
  name: 'offerPrice',
  props: {
    offer: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      demandStore: 'demandStore/demand',
      projectSelected: 'projectStore/projectSelected',
      servicesPrice: 'serviceStore/servicesPrice',
    }),
    exclTax() {
      return this.demandStore.show_price_ht;
    },
    isCeilingVisible() {
      return this.projectSelected.params.ceiling && this.repaymentCeiling > 0;
    },
    price() {
      return offersHelper.getPrice(this.offer, this.exclTax);
    },
    repaymentCeiling() {
      return offersHelper.getRepaymentCeiling(this.offer, this.demandStore);
    },
    isWarning() {
      return {
        'price__repayment__price--is-warning': this.repaymentCeiling < this.price + this.servicesPrice,
      };
    },
  },
};
</script>

<style scoped lang="scss">
  .price {
    width: 100%;
    display: flex;
    flex-direction: column;
    color: $--color-font;
    text-align: center;
    &__panel {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 20px;
      border-radius: 4px;
      background-color: $--color-light-grey;
      &__display {
        font-size: 30px;
        font-weight: 700;
      }
      &__subtitle {
        margin: 0;
      }
    }
    &__repayment {
      &__price {
        &--is-warning {
          color: $--color-warning;
        }
      }
    }
  }
</style>
